<app-header-logged></app-header-logged>
<div class="container">
  <img src="assets/images/permission.png" alt="No-permission">
  <h1>We are Sorry...</h1>
  <p>You don't have permission to view this page</p>
  <div class="action-btn">
    <cmp-button [class]="'primary'" (click)="onBack()" text="Go Back"></cmp-button>
  </div>
</div>
